import {request} from './index';

export type ExamChildType = {
  id: number;
  name: string;
};

export type PackageType = {
  id: number;
  name: string;
  status: boolean;
  exams: ExamChildType[];
  discountPercent: number;
  price: number;
  examCount: number;
  description: string;
};

export async function fetchPackages({
  queryKey: [_, search]
}: {
  queryKey: [string, string];
}): Promise<PackageType[]> {
  return await request(true, { url: `/packages/packages${search}` });
}
